export default __webpack_public_path__ + "static/possibl-42643ae2c5a13567ff1b64b9f79b3a84.png";